import GetStartedPage from "./GetStartedPage";

export default GetStartedPage;